import { render, staticRenderFns } from "./articel.vue?vue&type=template&id=1ce4231a&scoped=true&"
import script from "./articel.vue?vue&type=script&lang=js&"
export * from "./articel.vue?vue&type=script&lang=js&"
import style0 from "@/assets/main.css?vue&type=style&index=0&id=1ce4231a&scoped=true&lang=css&"
import style1 from "./articel.vue?vue&type=style&index=1&id=1ce4231a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce4231a",
  null
  
)

export default component.exports